import React, { useCallback, useRef, useState } from 'react';
import './testform.scss';
import Form, {
  Item,
  Label,
  ButtonItem,
  ButtonOptions,
  RequiredRule,
  EmailRule
} from 'devextreme-react/form';
import notify from 'devextreme/ui/notify';
import { LoadIndicator } from 'devextreme-react';

const emailEditorOptions = { stylingMode: 'filled', placeholder: 'Email', mode: 'email' };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Password', mode: 'password' };




const TestForm = () => {

  const rememberMeEditorOptions = {
    text: 'Remember me',
    elementAttr: { class: 'form-text' },
    onValueChanged: (e) => {
      console.log(e.value);
      if (e.value) {
        //formData.current = { ...formData.current, email: 'maureen@gmail.com' };
        setFormData({ ...formData, email: 'maureen@gmail.com' });
      } else {
        //formData.current = { ...formData.current, email: 'kgachomo@gmail.com' };
        setFormData({ ...formData, email: 'kgachomo@gmail.com' });
      }
    }

  };



  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: 'kgachomo@gmail.com', password: '' });


  const onSubmit = useCallback(async (e) => {
    e.preventDefault();
    const { email, password } = formData.current;
    setLoading(true);

    setLoading(false);
    notify('Validated Properly', 'error', 2000);
  },
    []);

  return (

    <div>
      <form onSubmit={onSubmit}>
        <Form formData={formData} disabled={loading}>
          <Item
            dataField={'email'}
            editorType={'dxTextBox'}
            editorOptions={emailEditorOptions}
          >
            <RequiredRule message="Email is required" />
            <EmailRule message="Email is invalid" />
            <Label visible={false} />
          </Item>
          <Item
            dataField={'password'}
            editorType={'dxTextBox'}
            editorOptions={passwordEditorOptions}

          >
            <RequiredRule message="Password is required" />
            <Label visible={false} />
          </Item>
          <Item
            dataField={'rememberMe'}
            editorType={'dxCheckBox'}
            editorOptions={rememberMeEditorOptions}
          >
            <Label visible={false} />
          </Item>
          <ButtonItem>
            <ButtonOptions
              width={'100%'}
              type={'default'}
              useSubmitBehavior={true}
            >
            </ButtonOptions>
          </ButtonItem>

        </Form>
      </form>
    </div>
  );
};
export default TestForm;
